
export class TeamService {

    getTeamsList(token1) { 
       //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/teams', {
        var respuesta = fetch(process.env.REACT_APP_URL+'teams', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token1
            },
            //body: JSON.stringify(credentials)
        })
        .then( function (data) {
            if (data.status != 200){
                console.log("error en respuesta");
                return "Error";
            }
            else{
                console.log("respuesta bien");
                return data.json();
            }
        });        
        return respuesta;
	}

    newTeam(teamData, token) {
        // var url = process.env.REACT_APP_URL+'teams';
        // console.log(url);
        //var respuesta = fetch('http://192.168.1.27/public/laraveldocker/public/api/teams', {
        var respuesta = fetch(process.env.REACT_APP_URL+'teams', {
            method: 'POST',
            // mode: 'cors',
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer '+token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(teamData)
        })
        .then(data => data.json().catch(() => ({ code: data.status, mensaje: 'Error al crear seleccion' })));
        console.log (respuesta);
        return respuesta;
    }

	getProducts() {
		return fetch('data/products.json').then(res => res.json()).then(d => d.data);
    }

    getProductsWithOrdersSmall() {
		return fetch('data/products-orders-small.json').then(res => res.json()).then(d => d.data);
	}
}
